export enum AlarmCategoryEnum {
  ANPR = 'ANPR',
  AHCR = 'AHCR'
}

export enum AnprCriterionTypeEnum {
  LICENSE_PLATE = 'LICENSE_PLATE',
  COLOR = 'COLOR',
  TYPE = 'TYPE'
}

export enum AhcrCriterionTypeEnum {
  GENDER = 'GENDER',
  JACKET_COLOR = 'JACKET_COLOR',
  HAT = 'HAT',
  MASK = 'MASK',
  SLEEVE_LENGTH = 'SLEEVE_LENGTH',
  BAG = 'BAG',
  TROUSER_COLOR = 'TROUSER_COLOR',
  TROUSER_LENGTH = 'TROUSER_LENGTH'
}

// Derive types from enums (no duplication)
export type AlarmCategory = `${AlarmCategoryEnum}`
export type AnprCriterionType = `${AnprCriterionTypeEnum}`
export type AhcrCriterionType = `${AhcrCriterionTypeEnum}`
export type CriterionType = AnprCriterionType | AhcrCriterionType